<template>
  <div>
    <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <h5>Política Comercial</h5>
        <b-button title="Adicionar nova política comercial" size="sm" @click="adicionar()" class="mr-1 ml-2">
          <i class="fe fe-plus"></i>
        </b-button>
      </div>
    </div>

    <lista class="mb-4" />
  </div>
</template>
<script>

import Lista from './lista'

export default {
  components: {
    Lista
  },
  data: function() {
    return {
    }
  },
  methods: {
    adicionar() {
      this.$router.push({
        name: 'politica-comercial-adicionar'
      })
    }
  },
  mounted() {
  }
}
</script>
